import { render } from "./passIcon.vue?vue&type=template&id=f6983858&scoped=true"
import script from "./passIcon.vue?vue&type=script&lang=js"
export * from "./passIcon.vue?vue&type=script&lang=js"

import "./passIcon.vue?vue&type=style&index=0&id=f6983858&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6983858"]])

export default __exports__